import { useTrackEventAmplitude } from '../../../../../core/Tracking/Amplitude/Amplitude';
import { SquareCard } from '../../../../../design-system/components/card/square/SquareCard';
import { Destination } from '../../../../../resources/destination/domain/types/destination';
import { getFacetTagCategoryTrackingProperty } from '../../../../../resources/facet/domain/operations/getFacetTagCategoryTrackingProperty';
import { getFacetTagNameTrackingProperty } from '../../../../../resources/facet/domain/operations/getFacetTagNameTrackingProperty';
import { Facet } from '../../../../../resources/facet/domain/types/facet';
import { useUrlGenerator } from '../../../../../shared/hooks/useUrlGenerator';
import { PickDomain } from '../../../../../shared/utilities/types/PickDomain';
import { imageLoaderForId } from '../../../Image/URL/ImageURL';

type PrimaryNavFacetCardProps = {
    facet: PickDomain<Facet, 'id' | 'slug' | 'title' | 'filter' | 'coverImage' | 'squareImage'>;
    destination: PickDomain<Destination, 'id' | 'slug'>;
    index: number;
};

export function PrimaryNavFacetCard({ facet, index, destination }: PrimaryNavFacetCardProps) {
    const { trackEvent } = useTrackEventAmplitude();
    const { generatePath } = useUrlGenerator();
    return (
        <SquareCard
            small={true}
            title={facet.filter.label}
            href={generatePath('facet', {
                facetSlug: facet.slug,
                destinationSlug: destination.slug,
            })}
            image={{
                alt:
                    (facet.squareImage
                        ? facet.squareImage.legend.toString()
                        : facet.coverImage.legend.toString()) || facet.title,
                fill: true,
                loader: imageLoaderForId({
                    aspectRatio: PrimaryNavFacetCard.PICTURE_RATIO,
                }),
                className: 'imageCover',
                src: facet.squareImage
                    ? facet.squareImage.id.toString()
                    : facet.coverImage.id.toString(),
                sizes: '120px',
            }}
            onClick={() => {
                trackEvent((ampli, defaultProperties) => {
                    ampli.primaryNavFacetClicked({
                        ...defaultProperties,
                        block: 'primary_nav',
                        facet_id: facet.id,
                        destination_id: destination.id,
                        destination_slug: destination.slug,
                        card_number: index + 1,
                        facet_tag_category: getFacetTagCategoryTrackingProperty(facet),
                        facet_tag_name: getFacetTagNameTrackingProperty(facet),
                    });
                });
            }}
        />
    );
}

PrimaryNavFacetCard.PICTURE_RATIO = SquareCard.PICTURE_RATIO;
